<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "SimpleLayout",
  computed: {
    simplePageClasses() {
      let simplePageClasses = ["document-upload"].includes(this.$route.name);
      return simplePageClasses;
    },
  },
};
</script>
